import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Allocations_ds_footprint_configurations_scopes_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { Key?: string, Value?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Allocations/datasources/ds_footprint_configurations_scopes_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { full_text_search?: string, $keys: string[] }): Promise<{ result?: { Key?: string, Value?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Allocations/datasources/ds_footprint_configurations_scopes_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      full_text_search?: string    }) {
      return false;
    }
}
